/* NS PL transform-only blade ignition V43 */
(() => {
  if (window.__nsCardGlowV43) return;
  window.__nsCardGlowV43 = true;

  const cardSelector = 'product-card.product-card';
  const activeSelector = `${cardSelector}.is-blade-glow-running, ${cardSelector}.is-blade-glow-complete`;

  const ensureFrame = (card) => {
    if (!(card instanceof HTMLElement)) return;

    let frame = card.querySelector(':scope > .ns-card-glow-frame');
    if (!frame) {
      frame = document.createElement('span');
      frame.className = 'ns-card-glow-frame';
      frame.setAttribute('aria-hidden', 'true');
      card.append(frame);
    }

    for (const side of ['top', 'right', 'bottom', 'left']) {
      if (frame.querySelector(`:scope > .ns-card-glow-edge--${side}`)) continue;
      const edge = document.createElement('i');
      edge.className = `ns-card-glow-edge ns-card-glow-edge--${side}`;
      frame.append(edge);
    }

    for (const strength of ['primary', 'secondary']) {
      if (frame.querySelector(`:scope > .ns-card-clash--${strength}`)) continue;
      const clash = document.createElement('span');
      clash.className = `ns-card-clash ns-card-clash--${strength}`;

      for (let spark = 0; spark < 8; spark += 1) {
        const particle = document.createElement('b');
        particle.className = 'ns-card-clash-spark';
        clash.append(particle);
      }

      frame.append(clash);
    }
  };

  const cardFromEvent = (event) => event.target instanceof Element
    ? event.target.closest(cardSelector)
    : null;

  document.addEventListener('pointerover', (event) => {
    const card = cardFromEvent(event);
    if (card) ensureFrame(card);
  }, true);

  document.addEventListener('pointerdown', (event) => {
    const card = cardFromEvent(event);
    if (card) ensureFrame(card);
  }, { capture: true, passive: true });

  document.addEventListener('focusin', (event) => {
    const card = cardFromEvent(event);
    if (card) ensureFrame(card);
  }, true);

  new MutationObserver((records) => {
    for (const record of records) {
      if (record.target instanceof HTMLElement && record.target.matches(activeSelector)) {
        ensureFrame(record.target);
      }
    }
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true,
  });

  document.querySelectorAll(activeSelector).forEach(ensureFrame);
})();
